import { resolvePrescriptionPackageCount } from './prescriptionPackageCount';

/** Quantidade exibida na impressão / visualização do item. */
export function formatPrescriptionItemQuantity(item: {
  quantity?: string | null;
  package_count?: number | null;
  is_two_packages?: boolean | null;
}): string {
  const base = String(item.quantity || '').trim();
  const packs = resolvePrescriptionPackageCount(item);
  if (packs > 1) {
    return base ? `${packs} embalagens (${base})` : `${packs} embalagens`;
  }
  return base;
}
